export function sortByLastVisitedAt<TEntry extends { lastVisitedAt: number }>(
  entries: TEntry[],
): TEntry[] {
  return [...entries].sort(
    (left, right) => right.lastVisitedAt - left.lastVisitedAt,
  )
}
